<script setup lang="ts">
import { useFloatingContactStore } from '../../../../store/contacts/floatingContact.ts';
import ContactResults from '../ContactResults/ContactResults.vue';
import ContactFinderInput from './ContactFinderInput/ContactFinderInput.vue';
import ContactFinderSelect from './ContactFinderSelect/ContactFinderSelect.vue';

export type Props = {
  type: 'input' | 'select';
  title: string;
  text?: string;
  placeholder?: string;
  validationPattern?: string;
  results?: ContactResultsProps;
  options?: ContactSelectProps;
  optionsTitle?: string;
};

type ContactResultsProps = InstanceType<typeof ContactResults>['$props'];
type ContactSelectProps = InstanceType<typeof ContactFinderSelect>['$props']['options'];

const stateStore = useFloatingContactStore();

const props = defineProps<Props>();

const submit = () => {
  stateStore.openFinder(props.type);

  // TODO(tracking): GA search submit
  // window.wtTrack.(extra: {
  //   event: 'fab_search_submitted,
  //   ...baseEventPayload({
  //     target: 'submit',
  //   }),
  // });
};
</script>
<template>
  <div :class="$style.container">
    <h3>{{ title }}</h3>
    <div v-if="text" v-html="text" />
    <ContactFinderInput
      v-if="type === 'input'"
      :placeholder="placeholder"
      :results="results"
      :validation-pattern="validationPattern"
      @submit="submit"
    />
    <ContactFinderSelect
      v-if="type === 'select'"
      :options="options"
      :options-title="optionsTitle"
      :placeholder="placeholder"
      :results="results"
      @submit="submit"
    />
  </div>
</template>
<style lang="sass" module src="./ContactFinder.scss" />
